import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "d-flex flex-column flex-shrink-0 bg-light border-end",
  style: {
    "width": "4.5rem"
  }
};
const _hoisted_2 = {
  class: "nav nav-pills nav-flush flex-column mb-auto text-center flex-grow-1"
};
const _hoisted_3 = {
  class: "nav-item"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa-regular fa-chart-line"
}, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("ul", _hoisted_2, [_createElementVNode("li", _hoisted_3, [_createVNode(_component_router_link, {
    to: {
      name: 'home'
    },
    "active-class": "active",
    class: "nav-link py-3 border-bottom rounded-0"
  }, {
    default: _withCtx(() => [_hoisted_4]),
    _: 1
  })])])]);
}